import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import * as firebase from 'firebase/app';
import { Observable, Subject } from 'rxjs/Rx';
import { LocalStorageService } from 'angular-2-local-storage';

import { User } from '../../modules/datamodel/user';
import { Institution } from '../../modules/datamodel/institution';

@Injectable()
export class AuthService implements CanActivate {
    private fbUserEmail$ : Subject < string | null >;
    public user : Subject < User >;
    public isLoggedIn : boolean = false;
    public loggedInUser: object;

    private usersCollection: AngularFirestoreCollection<User>;
    users: Observable<User[]>;

    private institutionsCollection: AngularFirestoreCollection<Institution>;
    institutions: Observable<Institution[]>;

    constructor(private afs: AngularFirestore, public afAuth: AngularFireAuth, public router: Router, protected storage: LocalStorageService) {
        this.usersCollection = this.afs.collection<User>('users');
        this.users = this.usersCollection.valueChanges();

        this.institutionsCollection = afs.collection<Institution>('institutions');
        this.institutions = this.institutionsCollection.valueChanges();

        this.fbUserEmail$ = new Subject()
        this.user = new Subject();
        this
            .afAuth
            .authState
            .subscribe(fbuser => {
                this.isLoggedIn = !!fbuser;
                this
                    .fbUserEmail$
                    .next(fbuser ? fbuser.email : null);
            });

        this
            .fbUserEmail$
            .switchMap(email => this.afs.collection('users', ref => ref.where('email', '==', email)).valueChanges())
            .subscribe(users => {
                this.loggedInUser = users;
                this.getUserProfile(users);
                //storage.set('users', JSON.stringify(users));
            });

    }

    get windowRef() {
        return window
    }

    public validateAuthUser(){
        return this.loggedInUser;
    }

    public getUserProfile(users) {
        if (!users || users.length < 1) {
            this
                .user
                .next(null);
        } else {
            this
                .user
                .next(users[0]);
        }
    }

    public signup(formModal, logoFileURL: string) {
        const afs = this.afs;
        const router = this.router;
        return firebase
            .auth()
            .createUserWithEmailAndPassword(formModal.email, formModal.password)
            .then(value => {
                var objUser = firebase.auth().currentUser;
                //create hospital
                afs.collection('institutions').add({
                    locations: [
                        {
                            name: formModal.hospname,
                            ref: ""
                        }
                    ],
                    logo: logoFileURL,
                    name: formModal.hospname,
                    address: formModal.address,
                    country: formModal.country,
                    state: formModal.state,
                    zipcode: formModal.zipcode,
                    city: formModal.city,
                    phone: formModal.phone
                }).then(function (res) {
                    const hospId = res.id;
                    const hospDoc = afs.doc('institutions/' + hospId);
                    afs.collection('users').doc(value.uid).set({
                        email: formModal.email,
                        first_name: formModal.first_name,
                        last_name: formModal.last_name,
                        phone: formModal.phone,
                        roles: { admin: true, superadmin: true },
                        hospital_id: hospId,
                        adminFor: [
                            {
                                name: formModal.hospname,
                                logo: logoFileURL,
                                id: hospId,
                                ref: hospDoc.ref
                            }
                        ],
                        preferences: { notifications: { email: true, push: true, sms: true } },
                        credentialedAt: [
                            {
                                name: formModal.hospname,
                                logo: logoFileURL,
                                ref: hospDoc.ref
                            }
                        ]
                    }).then(function (row){
                        firebase.database().ref('/userProfile').child(value.uid).set({
                            email: formModal.email,
                            name: formModal.first_name+' '+formModal.last_name,
                            phone: formModal.phone,
                            roles: { admin: true },
                            hospId: hospId
                        });
                    });
                    
                    router.navigate(['/home']);
                    return Promise.resolve();
                }).catch(function (error) {
                    console.error("Error writing document: ", error);
                });
            }).catch((err) => {
                console.log('Something went wrong:',err.message);
                return Promise.reject(err);
            });    
    }

    public login(username : string, password : string) {
        return firebase
            .auth()
            .signInWithEmailAndPassword(username, password)
            .then((confirmation) => {
                console.log(confirmation);
                this
                    .router
                    .navigate(['/home']);
                return Promise.resolve();
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    resetPassword(email: string) {
        var auth = firebase.auth();
        return auth.sendPasswordResetEmail(email)
            .then((confirmation) => {
                console.log(confirmation);
                this
                    .router
                    .navigate(['/login']);
                return Promise.resolve();
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    public loginWithPhone(phone : string, verifier) {
        return firebase
            .auth()
            .signInWithPhoneNumber(phone, verifier)
            .then((confirmation) => {
                console.log(confirmation);
                return Promise.resolve(confirmation);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    public verify(result : any) {
        console.log(result);
        this
            .router
            .navigate(['/home']);

        return Promise.resolve();
    }

    public logout() {
        console.log('logout');
        firebase
            .auth()
            .signOut()
            .then(() => {
                console.log('logged out');
                console.log(this.isLoggedIn);
                this
                    .router
                    .navigate(['/login']);
            })
            .catch((error) => {
                console.log(error);
            })
    }

    canActivate(next : ActivatedRouteSnapshot, state : RouterStateSnapshot) : Observable < boolean >| Promise < boolean > | boolean {
        return this
            .afAuth
            .authState
            .take(1)
            .map(authState => !!authState)
            .do(
                authenticated => {
                    if (!authenticated) {
                        this.router.navigate(['/login']);
                    }
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/auth/auth.service.ts